import React from 'react';

import { Link } from 'react-router';
import type { BrainAtlasType, MultiLang } from '../../config';
import Functions from '../../functions';
import iconFile from '../assets/images/icon_folder.gif';
import IndexUtil, { type Index } from './IndexUtil';

interface Props {
    lang: MultiLang;
    index: Index;
    type: BrainAtlasType;
}

const ListIndexItem: React.FC<Props> = (props) => {
    const { lang, index, type } = props;
    const url = IndexUtil.getUrl(type, index.id);
    const title = Functions.mlang(index.title, lang);
    const [numOfIndexes, setNumOfIndexes] = React.useState<number>(0);

    React.useEffect(() => {
        IndexUtil.countChildren(type, index.id, (count) => {
            setNumOfIndexes(count);
        });
    }, [index.id, type]);

    return (
        <table>
            <tbody>
                <tr>
                    <td className="listIcon">
                        <Link to={url}>
                            <img alt={title} src={iconFile} />
                        </Link>
                    </td>
                    <td>
                        <Link to={url}>{title}</Link>
                        <br />
                        {numOfIndexes} indexes / {index.numOfItems} items
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

const XoonipsListIndex: React.FC<Props> = (props) => {
    const { lang, index, type } = props;

    const [children, setChildren] = React.useState<Index[]>([]);

    React.useEffect(() => {
        IndexUtil.getChildren(type, index.id, (children) => {
            setChildren(children);
        });
    }, [index.id, type]);

    if (children.length === 0) {
        return null;
    }
    const treeList = children.map((value: Index, idx) => {
        const evenodd = idx % 2 === 0 ? 'even' : 'odd';
        return (
            <tr key={value.id}>
                <td className={evenodd}>
                    <ListIndexItem lang={lang} index={value} type={type} />
                </td>
            </tr>
        );
    });
    return (
        <table className="listTable">
            <tbody>{treeList}</tbody>
        </table>
    );
};

export default XoonipsListIndex;
